"use strict";

{
  const floatingCta = document.querySelector("[data-floating-cta]");
  const contact = document.getElementById("contact");
  const flow = document.getElementById("flow");
  const footer = document.querySelector(".p-footer");
  const flowTitle = flow?.querySelector(".p-flow__title");

  if (floatingCta && contact && flowTitle && footer) {
    let ticking = false;

    function setFloatingCtaVisible(shouldShow) {
      floatingCta.classList.toggle("is-visible", shouldShow);
      floatingCta.setAttribute("aria-hidden", shouldShow ? "false" : "true");
    }

    function updateFloatingCta() {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const contactRect = contact.getBoundingClientRect();
      const flowTitleRect = flowTitle.getBoundingClientRect();
      const footerRect = footer.getBoundingClientRect();
      const ctaHeight = floatingCta.offsetHeight || 0;
      const ctaTop = viewportHeight - ctaHeight;
      const hasReachedFlowTitle = flowTitleRect.bottom <= ctaTop;
      const isContactOverlappingCta = contactRect.bottom > ctaTop;
      const isFooterVisible = footerRect.top < viewportHeight;
      const shouldShow =
        hasReachedFlowTitle && isContactOverlappingCta === false && isFooterVisible === false;
      setFloatingCtaVisible(shouldShow);
    }

    function requestUpdate() {
      if (ticking) {
        return;
      }
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        updateFloatingCta();
      });
    }

    updateFloatingCta();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);
    window.addEventListener("load", updateFloatingCta);
  }
}
